const Config = {
  googleAnalyticsTrackingId: 'UA-17572030-23',
  toolbarLinks: [{
    to: 'https://twitter.com/vuecidity',
    icon: 'fa-twitter',
    external: true,
    hint: 'Follow @vuecidity'
  }, {
    to: '/getting-started/support-vuecidity',
    icon: 'fa-paypal',
    external: false,
    hint: 'Support the development of Vuecidity'
  }, {
    to: 'https://martinivanov.net',
    icon: 'mdi-wordpress',
    external: true,
    hint: 'Blog'
  }, {
    to: 'https://bitbucket.org/acidmartin/vuecidity',
    icon: 'mdi-bitbucket',
    external: true,
    hint: 'Bitbucket repo'
  }, {
    to: 'https://wemakesites.net/contact',
    icon: 'email',
    external: true,
    hint: 'Contact me'
  }],
  donationLinks: [{
    label: 'PayPal',
    to: 'https://www.paypal.me/acidmartin'
  }, {
    label: 'Patreon',
    to: 'https://www.patreon.com/vuecidity'
  }],
  links: [{
    label: 'Follow @vuecidity',
    to: 'https://twitter.com/vuecidity'
  }, {
    label: 'Portfolio',
    to: 'https://wemakesites.net'
  }, {
    label: 'VueRibbon',
    to: 'https://vueribbon.com/'
  }, {
    label: 'Blog',
    to: 'https://martinivanov.net/'
  }],
  resources: [{
    label: 'Made with VueJs',
    to: 'https://madewithvuejs.com/?ref=vuecidity.wemakesites.net'
  }, {
    label: 'VueJs Ribbon',
    to: 'https://vueribbon.com/'
  }, {
    label: 'VueJs feed',
    to: 'https://vuejsfeed.com/?ref=vuecidity.wemakesites.net'
  }, {
    label: 'Icon resources',
    to: 'http://icons.wemakesites.net/'
  }, {
    label: 'Material Design guidelines',
    to: 'https://material.io/'
  }, {
    label: 'VueJs Jobs',
    to: 'https://vuejobs.com/?ref=vuecidity.wemakesites.net'
  }, {
    label: 'VueJs Radar',
    to: 'https://www.vuejsradar.com/?ref=vuecidity.wemakesites.net'
  }]
}

export default Config



// WEBPACK FOOTER //
// ./src/helpers/config.js